import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import apiService from '../utils/api';
import useRoadmapStore from '../store/roadmapStore';

/**
 * Hook that provides AI suggest functionality for any step page.
 * Returns a handler that calls the AI suggest API and applies the result.
 */
export default function useAISuggest(stepName) {
  const { i18n } = useTranslation();
  const currentRoadmapId = useRoadmapStore(s => s.currentRoadmapId);
  const updateStepData = useRoadmapStore(s => s.updateStepData);

  const handleAISuggest = useCallback(async () => {
    if (!currentRoadmapId) {
      throw new Error('Save your project first before using AI suggestions.');
    }
    const result = await apiService.suggestStep(currentRoadmapId, stepName, i18n.language);
    if (result && typeof result === 'object') {
      // Remove the 'completed' field — don't let AI mark steps complete
      const { completed, ...stepData } = result;
      updateStepData(stepName, stepData);
    }
    return result;
  }, [currentRoadmapId, stepName, i18n.language, updateStepData]);

  return handleAISuggest;
}
